import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Password from '@/components/Password'
import User from '@/components/User'
import Fournisseur from '@/components/Fournisseur'
import Entrepot from '@/components/Entrepot'
import Drive from '@/components/Drive'

//import Maintenance from '@/components/Maintenance'
import Parametre from '@/components/Parametre'
import Keywords from '@/components/Keywords'
import Produit from '@/components/Produit'
import Projet from '@/components/Projet'
import Caisse from '@/components/Caisse'
// import Demande from '@/components/Demande'
import DemandeFond from '@/components/demandeFond/Demande_fond_index'
import Validation from '@/components/Validation'
import Routes from '@/components/Routes'
import DetailDemande from '@/components/DetailDemande'
import ParcAuto from '@/components/ParcAuto'
import Flotte from '@/components/Flotte'
import Planning from '@/components/calendrier/Planning'
import FicheVehicule from '@/components/FicheVehicule'
import listeOuvrier from '@/components/ouvrier/listeOuvrier'
//import ValidationDmd from '@/components/ValidationDmd'
import ValidationDmd from '@/components/validationDG/Validation_index'
import Mission from '@/components/mission/Mission'
import Chantier from '@/components/Chantier'
import Besoin from '@/components/Besoin'
import Maintenance from '@/components/maintenance/Maintenance_index'
import Comparateur from '@/components/comparateur/comparateur_index'
import IndexBoardChantier from '@/components/boardChantier/Index_board_Chantier'
import IndexProjet from '@/components/boardProjet/indexProjet'
import DashboardTravaux from '@/components/boardTravaux/DashboardTravaux'
import ListeTableau from '@/components/gestionTache/ListeTableau'
import CompteExploitation from '@/components/projet/CompteExploitation'
import BudgetProjet from '@/components/projet/BudgetProjet'
import BudgetChantier from '@/components/projet/BudgetChantier'
import Client from '@/components/Client'
import Worklogs from '@/components/worklogs/Worklogs'
import Revuebudgetaire from '@/components/Projet/RevueBudgetaire'
import facturePaiement from '@/components/validationDG/facturePaiement'
import boardResource from '@/components/resourceHumaine/board_resource'
import indexResource from '@/components/resourceHumaine/index_resource'
import detailEmploye from '@/components/resourceHumaine/detail_employe'
import listeContrat from '@/components/resourceHumaine/liste_contrat'
import listeDemande from '@/components/resourceHumaine/liste_demande'
import boardEmploye from '@/components/resourceHumaine/boardEmploye'
import dashboardReporting from '@/components/reporting/dashboardReporting'
import RechercheInfo from '@/components/tierce/RechercheInfo'
import IndicateurProjet from '@/components/projet/IndicateurProjet'


//import fullCalendar from 'vue-fullcalendar'
//Vue.component('full-calendar', fullCalendar)


Vue.use(Router)

export default new Router({
  routes: [
    // { path: '/', name: 'Home', component: Home },
    { path: '/', name: 'Home', component: Besoin },
    { path: '/client', name: 'Client', component: Client },
    { path: '/login', name: 'Login', component: Login },
    { path: '/routes/expo', name: 'routes', component: Routes },
    { path: '/password', name: 'Password', component: Password },
    { path: '/user', name: 'User', component: User },
    { path: '/fournisseur', name: 'Fournisseur', component: Fournisseur },
    { path: '/drive', name: 'Drive', component: Drive },
    { path: '/maintenance', name: 'Maintenance', component: Maintenance },
    { path: '/parametre', name: 'Parametre', component: Parametre },
    { path: '/keywords', name: 'Keywords', component: Keywords },
    { path: '/produit', name: 'Produit', component: Produit },
    { path: '/entrepot', name: 'Entrepot', component: Entrepot },
    { path: '/projet', name: 'Projet', component: Projet },
    { path: '/compteExpo', name: 'CompteExp', component: CompteExploitation },
    { path: '/budgetProjet', name: 'BudgetProjet', component: BudgetProjet },
    { path: '/budgetChantier', name: 'BudgetChantier', component: BudgetChantier },
    { path: '/chantier', name: 'Chantier', component: Chantier },
    { path: '/caisse', name: 'Caisse', component: Caisse },
   // { path: '/demande', name: 'Demande', component: Demande },
    { path: '/demandeFond', name: 'DemandeFond', component: DemandeFond },
    { path: '/validation', name: 'Validation', component: Validation },
    { path: '/listeOuvrier', name: 'listeOuvrier', component: listeOuvrier },
    { path: '/validationDmd', name: 'ValidationDmd', component: ValidationDmd },
    { path: '/detail/demande/:demande_id', name: 'DetailDemande', component: DetailDemande },
    { path: '/parc/auto', name: 'ParcAuto', component: ParcAuto },
    { path: '/parc/auto/flotte/:etat_veh', name: 'Flotte', props: true, component: Flotte },
    { path: '/parc/auto/fiche/:id', name: 'FicheVehicule', props: true, component: FicheVehicule },
    { path: '/planning/chantier/:id', name: 'Planning', props: true, component: Planning },
    { path: '/mission', name: 'Mission',  component: Mission },
    { path: '/besoin', name: 'Besoin',  component: Besoin },
    { path: '/comparateur', name: 'Comparateur',  component: Comparateur},
    { path: '/boardChantier', name: 'DashBoardChantier', component: IndexBoardChantier },
    { path: '/boardProjet', name: 'DashBoardProjet', component: IndexProjet },
    { path: '/boardTravaux', name: 'DashboardTravaux', component: DashboardTravaux },
    { path: '/tableauxTache', name: 'ListeTableau', component: ListeTableau },
    { path: '/worklogs', name: 'Worklogs', component: Worklogs },
    {path: '/revuebudgetaire', name: 'Revuebudgetaire', component: Revuebudgetaire},
    { path: '/boardFacture', name: 'facturePaiement', component: facturePaiement },
    { path: '/boardResource', name: 'boardResource', component: boardResource },
    { path: '/indexResource', name: 'indexResource', component: indexResource },
    //{ path: '/detailEmploye', name: 'detailEmploye', component: detailEmploye },
    //{ path: '/listeContrat', name: 'listeContrat', component: listeContrat },
    { path: '/liste', name: 'listeContrat', component: listeContrat },
    { path: '/listeDemande', name: 'listeDemande', component: listeDemande },
    { path: '/detailEmploye', name: 'detailEmploye', component: detailEmploye },
    { path: '/boardEmploye', name: 'boardEmploye', component: boardEmploye },
    { path: '/reporting', name: 'dashboardReporting', component: dashboardReporting },
    { path: '/search', name: 'RechercheInfo', component: RechercheInfo },
    { path: '/indicateur/projet', name: 'IndicateurProjet',  component: IndicateurProjet }

    //{ path: '/maintenance', name: 'Maintenance', component: Maintenance },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js